const SELECCIONAR = 'SELECCIONAR'
const INGRESOS = 'INGRESOS'
const GASTOS = 'GASTOS'

const __dictionary = {
  [SELECCIONAR]: {
    id: [SELECCIONAR],
    nombre: 'SELECCIONAR',
  },
  [INGRESOS]: {
    id: [INGRESOS],
    nombre: 'INGRESOS',
  },
  [GASTOS]: {
    id: [GASTOS],
    nombre: 'GASTOS',
  }
}

const __array = [__dictionary[SELECCIONAR], __dictionary[INGRESOS], __dictionary[GASTOS]]

export default Object.freeze({
  SELECCIONAR: SELECCIONAR,
  INGRESOS: INGRESOS,
  GASTOS: GASTOS,
  __dictionary,
  __array
})
